var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCauzeLogoConfirmed = function SvgCauzeLogoConfirmed(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 54,
    viewBox: "0 0 48 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1312 16.4686C23.0441 14.5288 23.0441 11.3837 21.1312 9.44393C19.2183 7.50411 16.1168 7.50411 14.2039 9.44393C12.291 11.3837 12.291 14.5288 14.2039 16.4686C16.1168 18.4085 19.2183 18.4085 21.1312 16.4686Z",
    fill: "#1B2031"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3709 16.835C38.8996 19.5359 36.3593 21.341 33.6958 20.8631C31.0323 20.3852 29.2523 17.8091 29.7236 15.1082C30.1949 12.4073 32.7352 10.6023 35.3987 11.0802C38.0621 11.5581 39.8421 14.1341 39.3709 16.835Z",
    fill: "#1B2031"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0773 28.4914L40.6536 30.9392C39.0082 40.3941 30.1163 46.7068 20.7909 45.0432C11.4671 43.3747 5.24195 34.3578 6.88239 24.9013L7.30605 22.4535L16.9533 24.1802L16.5297 26.6281C15.8269 30.6778 18.4936 34.5426 22.4888 35.2603C26.4824 35.973 30.2937 33.2688 31.0014 29.2174L31.4251 26.7696L41.0773 28.4914Z",
    fill: "#1B2031"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCauzeLogoConfirmed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cauze-logo-confirmed.fa52b6673c47a1b23873ad621c6c9c20.svg";